import { AssemblyItem } from '../../../api/elite/types/assembly-item';
import { SchedulerItem } from '../../../common/scheduler/models/item';
export type FilterSchedulerItem = FilterWorkOrder | FilterSubWorkOrder;
import { SchedulerSubWorkOrder } from '../../../common/scheduler/models/sub-work-order';
import { QualityControlWorkOrder } from '../../../common/quality-control/model/work-order-qc.ts';
import { InspectionAssemblyItem } from '../../../api/elite/types/inspection-assembly-item';
import { Inspection } from '../../../api/elite/types/inspections';

export class FilterWorkOrder extends QualityControlWorkOrder {
  assemblyItem: AssemblyItem;
  quantityPacked: number;
  quantityBuilt: number;
  quantityRemaining: number;
  quantityRequired: number;
  quantityToApprove: number;
  // tslint:disable-next-line:variable-name
  __classRow?: string;

  typeId: number;
  subWorkOrders: FilterSubWorkOrder[];
  inspections: Inspection[];

  builtReport: number;
  createdAt: Date;
  location: string;
  destination: string;

  get quantity(): number {
    return this.quantityRequired;
  }

  get workOrderId(): number {
    return this.transactionId;
  }

  get currentMeasureValues(): InspectionAssemblyItem {
    return this.assemblyItem.inspectionAssemblyItem?.find(
      (op) => !op.obsoleteDate
    );
  }

  get quantityToDo(): number {
    return this.quantityRequired;
  }

  get nextStage(): FilterSubWorkOrder {
    return this.subWorkOrders ? this.subWorkOrders[0] : null;
  }

  get assemblyTitle(): string {
    return this.assemblyItem.title;
  }

  get assemblyType(): string {
    if (
      !this.assemblyItem?.typesList ||
      this.assemblyItem?.typesList?.length === 0
    ) {
      return '';
    }
    return this.assemblyItem?.typesList[0]?.title || '';
  }

  get assemblyTypeId(): number | undefined {
    if (
      !this.assemblyItem?.typesList ||
      this.assemblyItem?.typesList?.length === 0
    ) {
      return undefined;
    }
    return this.assemblyItem?.typesList[0]?.id;
  }

  get itemName(): string {
    return this.assemblyItem.title;
  }

  get quantityLabel(): number {
    const nextStage = this.nextStage ? this.nextStage.quantity : 0;
    const quantityToApprove = this.quantityToApprove || 0;
    return nextStage + quantityToApprove + this.quantityBuilt;
  }

  get quantityStock(): number {
    return this.builtReport || 0;
  }

  static fromObject(object: SchedulerItem): FilterWorkOrder {
    const workOrder = new FilterWorkOrder();
    Object.assign(workOrder, object);
    return workOrder;
  }
}

export class FilterSubWorkOrder extends SchedulerSubWorkOrder {
  workOrder: FilterWorkOrder;
  // tslint:disable-next-line:variable-name
  __classRow?: string;

  get assemblyItem(): AssemblyItem {
    return this.workOrder.assemblyItem;
  }
  get specialInstructions(): string {
    return this.workOrder.specialInstructions;
  }

  get currentMeasureValues(): InspectionAssemblyItem {
    return this.assemblyItem.inspectionAssemblyItem?.find(
      (op) => !op.obsoleteDate
    );
  }

  get maxQuantityToUse(): number {
    return this.quantity;
  }

  get stageName(): string {
    return this.stage?.title || '';
  }

  get assemblyDescription(): string {
    return this.workOrder.assemblyDescription;
  }

  get transactionNumber(): string {
    return this.workOrder.transactionNumber;
  }

  get endDate(): Date {
    return this.workOrder.endDate;
  }

  get quantityToDo(): number {
    return this.workOrder.quantityToDo;
  }

  get quantityRequired(): number {
    return this.workOrder.quantityRequired;
  }

  get quantityBuilt(): number {
    return this.workOrder.quantityBuilt;
  }

  set quantityBuilt(value: number) {
    this.workOrder.quantityBuilt = value;
  }

  get builtReport(): number {
    return this.workOrder.builtReport;
  }

  set builtReport(value: number) {
    this.workOrder.builtReport = value;
  }

  get assemblyTitle(): string {
    return this.workOrder.assemblyItem.title;
  }

  get assemblyType(): string {
    return this.workOrder.assemblyType;
  }

  get quantityLabel(): number {
    const quantityToApprove = this.workOrder.quantityToApprove || 0;
    const quantityBuilt = this.workOrder.quantityBuilt;
    return quantityToApprove + quantityBuilt;
  }

  get quantityStock(): number {
    return this.quantity;
  }

  static fromObject(json: SchedulerSubWorkOrder): FilterSubWorkOrder {
    const item = new FilterSubWorkOrder();
    Object.assign(item, json);
    item.workOrder = FilterWorkOrder.fromObject(json.workOrder);
    return item;
  }

  static transformToWorkOrder(obj: SchedulerSubWorkOrder): FilterWorkOrder {
    const item = new FilterSubWorkOrder();
    Object.assign(item, obj);
    item.workOrder = new FilterWorkOrder();
    Object.assign(item.workOrder, obj.workOrder);
    item.workOrder.subWorkOrders = [item];
    item.workOrder.qcSubWorkOrder = item;
    return item.workOrder;
  }
}
